import CryptoJS from 'crypto-js';

const secretKeyBase64 = import.meta.env.VITE_APP_KEY;
const secretKey = CryptoJS.enc.Base64.parse(secretKeyBase64); 
const iv = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_APP_IV); // IV de 16 caractères

function base64UrlEncode(base64) {
    return base64
        .replace(/\+/g, '-') // Remplacer '+' par '-'
        .replace(/\//g, '_') // Remplacer '/' par '_'
        .replace(/=+$/, ''); // Supprimer les '=' de padding
}

function encryptData(data) {
    const encrypted = CryptoJS.AES.encrypt(data.toString(), secretKey, {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: iv,
    }).toString();

    // Convertir en Base64 URL-safe
    return base64UrlEncode(encrypted);
}

export default encryptData;